import React from 'react';
import classNames from 'classnames';
import { FormPureComponentItem } from '../generic.component.jsx';
import style from './dont.know.btn.less';
import { specialValues } from '../../constants.jsx';
import { KEY_CODES } from '../../../common/utils.jsx';
import _ from '../../i18n.jsx';

const { UNKNOWN } = specialValues;
const { ENTER, SPACE } = KEY_CODES;

export default class DontKnowBtn extends FormPureComponentItem {
    constructor() {
        super();
        this.onKeyPressHandler = this.onKeyPressHandler.bind(this);
    }

    onKeyPressHandler(event) {
        const disabled = this.props.disabled;
        const keyCode = event.keyCode;
        if ((ENTER === keyCode || SPACE === keyCode) && !disabled) {
            this.onChangeHandler(event);
            event.preventDefault();
        }
    }
    render() {
        const { id, name, value, checked, disabled, wrapperClass } = this.props;
        const cssWrapperClass = classNames(wrapperClass, style.labelWrapper, { [style.active]: checked });
        const tabIndex = disabled ? -1 : 0;
        return (
            <label htmlFor={id} className={cssWrapperClass} tabIndex={tabIndex} onKeyDown={this.onKeyPressHandler}>
                <input checked={checked} onChange={this.onChangeHandler} type="radio" name={name} value={value} id={id} tabIndex={tabIndex} className={style.hiddenCheckbox}/>
                <span className={style.label}>{_(`Don't know`)}</span>
            </label>
        );
    }
}
DontKnowBtn.defaultProps = { value: UNKNOWN };
